import React, { useEffect, useRef, useState } from "react";
import placeimage from "../Assets/Splash/banner1.png";
import galleryupload from "../Assets/Splash/upload.svg";
import "../Style/Component/Banner.css";
import edit from "../Assets/Splash/edit.svg";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import {
  deleteWithTokenAPI,
  postWithoutTokenAPI,
  postWithTokenAPI,
  putWithTokenAPI,
} from "../Util/Api.js";
import { isEditable } from "@testing-library/user-event/dist/utils/index.js";
import { X } from "lucide-react";

import { toast } from "react-toastify";

const Banner = ({ details, onChange, isNew, type, ordercount }) => {
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [desc, setDesc] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [order, setOrder] = useState(1);
  const [link, setLink] = useState("");
  const [preview, setPreview] = useState("");
  const auth = useSelector((state) => state.auth);
  const fileRef = useRef(null);
  const [imageUrl, setImageUrl] = useState("");
  const [previewimage, setPreviewImage] = useState("");
  const [isEditable, setIsEditable] = useState(false);

  const token = auth.token;
  const adminId = auth.userId;
  const permission = auth.permission;
  useEffect(() => {
    if (details && !details.isNew) {
      setTitle(details?.main_topic || "");
      setSubtitle(details?.sub_content || "");
      setDesc(details?.description || "");
      setPreview(details?.banner_image || placeimage);
      setImageUrl(details?.imageUrl || "");
      setOrder(details?.banner_order);
    }

    if (details?.isNew) {
      setTitle("");
      setSubtitle("");
      setDesc("");
      setLink("");
      setPreview(placeimage);
      setImageUrl("");
      setOrder(ordercount);
    }
  }, [details]);
  useEffect(() => {
    if (isNew) {
      setIsEditable(true);
    }
  }, [isNew]);
  const handleImagePick = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImageFile(file);
    // setPreview(URL.createObjectURL(file));

    try {
      const uploadedUrl = await uploadImage(file);
      setPreview(uploadedUrl);
    } catch (err) {
      toast.error("Image upload failed");
    }
  };

  const uploadImage = async (file) => {
    const formData = new FormData();
    formData.append("files", file);

    const res = await postWithoutTokenAPI(
      `/upload_image?userId=${adminId}&type=admin`,
      formData,
    );
    if (res?.data?.[0]?.fileUrl) {
      return res?.data?.[0]?.fileUrl;
    } else {
      toast.error("Image Could not Upload");
    }
  };

  const handleUpload = async () => {
    if (!title) {
      toast.error("Title is required");
      return;
    }

    if (!preview && !details?.banner_image) {
      toast.error("Please upload banner image");
      return;
    }

    const cleanUrl = (url = "") => url.replace(/^"+|"+$/g, "").trim();

    const payload = {
      banner_image: cleanUrl(preview || details?.banner_image),
      main_topic: title,
      sub_content: subtitle,
      description: desc,
      imageUrl: imageUrl,
      banner_order: order || ordercount,
      is_active: true,
      banner_for: type,
    };
    try {
      let response;
      if (details?._id) {
        response = await putWithTokenAPI(
          token,
          `/banner/update/${details._id}`,
          payload,
        );
      } else {
        response = await postWithTokenAPI(token, `/banner/create`, payload);
      }
      if (
        response?.success ||
        response?.statusCode === 200 ||
        response?.statusCode === 201
      ) {
        toast.success(details?._id ? "Banner updated" : "Banner created");
        onChange?.(response?.data);
      } else {
        toast.error("Banner save failed");
      }
    } catch (err) {
      console.error(err);
      toast.error("Banner upload error");
    }
  };

  const handleDelete = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This category will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, Delete",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await deleteWithTokenAPI(
            token,
            `/banner/delete/${details._id}`,
          );

          if (response?.statusCode === 200) {
            toast.success("Banner deleted successfully");
            onChange(null);
          } else {
            toast.error("Delete failed");
          }
        } catch (error) {
          console.error(error);
          toast.error(error);
        }
      }
    });
  };

  return (
    <div className="bannercardd">
      {!isEditable && permission?.splash_screen?.update && (
        <img
          src={edit}
          className="banneredit"
          onClick={() => setIsEditable(!isEditable)}
        ></img>
      )}
      {isEditable && (
        <div className="banneredit" onClick={() => setIsEditable(!isEditable)}>
          <X
            size={24}
            style={{
              color: "white",
              backgroundColor: "rgb(169, 4, 4)",
              fontWeight: "500",
              border: "2px solid white",
              borderRadius: "50%",
            }}
          />
        </div>
      )}
      <span className="bannercount">
        Banner:{details?.banner_order || ordercount}
      </span>
      <div
        className="banner-image-wrapper"
        onClick={() => fileRef.current.click()}
      >
        <img
          src={preview || details?.banner_image || placeimage}
          // style={{ objectFit: placeimage ? "contain" : "cover" }}
          className="bannercardimage"
          // onClick={() => fileRef.current.click()}
          style={{ cursor: "pointer" }}
        />
        {isEditable && permission?.splash_screen?.update && (
          <div className="image-overlay">
            <img src={galleryupload} alt="Upload" />
            <span>Upload Image</span>
          </div>
        )}
      </div>
      <input
        type="file"
        hidden
        ref={fileRef}
        accept="image/*"
        disabled={!isEditable}
        onChange={(e) => handleImagePick(e)}
      />
      <form className="bannercardcontent">
        <label htmlFor="main">Main Topic</label>
        <input
          id="main"
          type="text"
          value={title}
          disabled={!isEditable}
          onChange={(e) => {
            setTitle(e.target.value);
          }}
          placeholder="Enter main topic"
        />

        <label htmlFor="sub">
          Sub Content <span className="opt">(Optional)</span>
        </label>
        <input
          id="sub"
          type="text"
          value={subtitle}
          disabled={!isEditable}
          onChange={(e) => {
            setSubtitle(e.target.value);
          }}
          placeholder="Enter sub content"
        />

        <label htmlFor="desc">Description</label>
        <input
          id="desc"
          type="text"
          value={desc}
          disabled={!isEditable}
          onChange={(e) => {
            setDesc(e.target.value);
          }}
          placeholder="Enter sub content"
        />

        <label htmlFor="link">
          Link <span className="opt">(Optional)</span>
        </label>
        <input
          id="link"
          type="text"
          value={imageUrl}
          disabled={!isEditable}
          onChange={(e) => {
            setImageUrl(e.target.value);
          }}
          placeholder="Enter Target Link"
        />
        {/* <label>Banner Image</label> */}
        {/* <div className="uploadbtn updatebtn">
          <img src={galleryupload} />
          Upload
          <input
            type="file"
            hidden
            accept="image/*"
            // onChange={(e) => {
            //   const file = e.target.files[0];
            //   if (!file) return;
            //   const url = URL.createObjectURL(file);
            //   setPreview(url);

            //   onChange({
            //     ...details,
            //     imageFile: file,
            //     imagePreview: url,
            //   });
            // }}
          />
        </div> */}
        {/* <button type="button" className="uploadbtn">
          <img src={galleryupload} />
          {details?._id ? "Update" : "Upload"}
        </button> */}
        <div className="bottom-buttons">
          {permission?.splash_screen?.delete && (
            <button
              type="button"
              className="delbtn"
              onClick={() => handleDelete()}
            >
              Delete
            </button>
          )}
          {permission?.splash_screen?.update && (
            <button
              type="button"
              className="confirmgreen"
              style={{
                background: "#1FA900",
              }}
              onClick={(e) => {
                e.preventDefault();
                handleUpload();
              }}
            >
              Confirm
              {/* <button type="submit">Confirm</button> */}
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default Banner;
